import {useQuery} from "@tanstack/react-query";
import {LevelConfigResponse, UtilsApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchLevelConfigs(): Promise<Array<LevelConfigResponse>> {
    const response = await new UtilsApi(getConfig()).getUtilsLevelConfigs();
    return response.levelConfigs || [];
}

/**
 * Fetches dynamic level configs from the public API.
 * Consumers should fall back to hardcoded data when data is empty/undefined —
 * this covers both "no configs configured" and "API error" cases by design.
 */
export function useGetLevelConfigs() {
    return useQuery({
        queryKey: ["level-configs"],
        queryFn: fetchLevelConfigs,
        staleTime: 30 * 60 * 1000,
        gcTime: 60 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    });
}
